import {
    GET_USERDETAILS_SUCCESS,
    GET_USERDETAILS_FAILED,
    GET_USERDETAILS_NOTFOUND,
    GET_USERDETAILS_INVALIDREQUEST,
    LOADING_USERDETAILS,
    RESET_USERDETAILS,
} from "../types";


const initialState = {
    isLoading: false,
    failed: false,
    notFound: false,
    invalidRequest: false,
    success: false,
    data: {},
    status: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_USERDETAILS:
            return {
                ...state,
                isLoading: true,
                failed: false,
                notFound: false,
                invalidRequest: false,
                success: false,
                data: {},
                status: ""
            };
        case GET_USERDETAILS_FAILED:
            return {
                ...state,
                isLoading: false,
                failed: true,
                notFound: false,
                invalidRequest: false,
                success: false,
                data: action.payload,
                status: ""
            };
        case GET_USERDETAILS_NOTFOUND:
            return {
                ...state,
                isLoading: false,
                failed: false,
                notFound: true,
                invalidRequest: false,
                success: false,
                data: action.payload,
                status: ""
            };
        case GET_USERDETAILS_INVALIDREQUEST:
            return {
                ...state,
                isLoading: false,
                failed: false,
                notFound: false,
                invalidRequest: true,
                success: false,
                data: action.payload,
                status: ""
            };
        case GET_USERDETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                failed: false,
                notFound: false,
                invalidRequest: false,
                success: true,
                data: action.payload,
                status: ""
            };

        case RESET_USERDETAILS:
            return (state = initialState);

        default:
            return state;
    }
};